// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Err from "../bindings/Err.js";
import * as Preact from "../bindings/Preact.js";
import * as QRCode from "../bindings/QRCode.js";

async function generateQRCode(text, options) {
  if (!QRCode.isQRCodeAvailable()) {
    Err.$$throw("QRCode library is not loaded");
  }
  return await QRCode.generateQRCode(text, options);
}

function downloadQRCode(dataUrl, filenameOpt) {
  let filename = filenameOpt !== undefined ? filenameOpt : "qrcode.png";
  let link = document.createElement("a");
  link.download = filename;
  link.href = dataUrl;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function generateCustomerURL(storeId) {
  let baseUrl = window.location.origin + window.location.pathname;
  return baseUrl + `#/q/` + storeId;
}

function generateAdminURL(adminId) {
  let baseUrl = window.location.origin + window.location.pathname;
  return baseUrl + `#/admin/` + adminId;
}

function generateDisplayURL(storeId) {
  let baseUrl = window.location.origin + window.location.pathname;
  return baseUrl + `#/display/` + storeId;
}

function expose() {
  Preact.setWindowProperty("QRUtils", {
    generateQRCode: generateQRCode,
    downloadQRCode: downloadQRCode,
    generateCustomerURL: generateCustomerURL,
    generateAdminURL: generateAdminURL,
    generateDisplayURL: generateDisplayURL
  });
}

export {
  generateQRCode,
  downloadQRCode,
  generateCustomerURL,
  generateAdminURL,
  generateDisplayURL,
  expose,
}
/* No side effect */
